import { useState } from 'react';

import { Button } from '@armis/armis-ui-library';
import { LOGIN_WITH_SSO } from 'src/constants/LabelText';
import { loginWithSAML2 } from 'src/services/api.service';

import { GovernmentBanner } from '../GovernmentBanner';
import { ButtonContainer } from '../Login.style';

export const BasicAuth = () => {
    const [showBanner, setShowBanner] = useState(true);

    const handleBannerAccept = () => {
        setShowBanner(false);
    };

    return (
        <>
            <GovernmentBanner onAccept={handleBannerAccept} open={showBanner} />
            <ButtonContainer>
                <Button
                    color="special"
                    fullWidth
                    href={loginWithSAML2()}
                    style={{ backgroundColor: '#2ABAFF' }}
                    variant="contained"
                >
                    {LOGIN_WITH_SSO}
                </Button>
            </ButtonContainer>
        </>
    );
};
